import { logout } from '@/redux/slices/user.slice';
import { fetchPatients } from '@/redux/thunks/patients.thunk';
import { createSlice } from '@reduxjs/toolkit';

interface PatientsState { 
  data: any[];
  pagination: {
    allRecords: any[],
    totalRecords: number,
    totalPages: number,
    currentPage: number,
    pageSize: number
  },
  loading: boolean;
  success: boolean;
  error: any | boolean;
}

const initialState: PatientsState = {
    data: [],
    pagination: {
      allRecords: [],
      totalRecords: 0,
      totalPages: 0,
      currentPage: 0,
      pageSize: 0
    },
    loading: false,
    success: true,
    error: false,
};

const patientsSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    clearPatients: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatients.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = false;
      })
      .addCase(fetchPatients.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchPatients.rejected, (state, action) => {
        state.loading = false
        state.success = false;
        state.error = action.error
      });
      builder.addCase(logout, () => {
      return initialState;
    })
  },
});

export const { clearPatients } = patientsSlice.actions;
export default patientsSlice.reducer;
